export default __webpack_public_path__ + "static/media/busd.e164e45f.png";